<div *ngIf="isCorrectionOfItem$ | async">
    <span class="badge badge-light">{{'mydspace.results.is-correction' | translate}}</span>
</div>